export default {
  desktop: 1280,
  tablet: 1024,
  tabletSmall: 768,
  mobile: 480,
};
